import { render, staticRenderFns } from "./ComentariosPagamento.vue?vue&type=template&id=1f06cbde&scoped=true"
import script from "./ComentariosPagamento.vue?vue&type=script&lang=js"
export * from "./ComentariosPagamento.vue?vue&type=script&lang=js"
import style0 from "./ComentariosPagamento.vue?vue&type=style&index=0&id=1f06cbde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f06cbde",
  null
  
)

export default component.exports